import _get from 'lodash/get';

function getFormEndpoint(formId) {
    return `${_get(location, 'origin') || ''}/api/forms/${btoa(formId)}/submit`;
}

export {
    getFormEndpoint,
}
